import React from "react";
import "./Footer.css";
import logo from "../Assets/logo.svg"
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="vangal-footer-wrapper">
      <div className="vangal-footer-container">
        <div className="vangal-footer-left">
          <img
            src={logo}
            alt="Vangal Logo"
            className="vangal-footer-logo"
          />

          <p className="vangal-footer-company">
            GOPIKA AGRO PRODUCT PVT. LTD<br />
            PLANT : #54, PERIYAGOUNDANPATTI,<br />
            THALAMBADI VILLAGE, NAMAKKAL,<br />
            TAMILNADU - 637 019<br />
            04286 - 294399 / 299<br />
            WWW.GOPIKAAGRO.COM
          </p>
        </div>
        <div className="vangal-footer-right">
          <ul className="vangal-footer-links">
            <h2>Quick links</h2>
            <li><a href="/">Home</a></li>
  <li><a href="/about">About Us</a></li>
  <li><a href="/products">Products</a></li>
  <li><a href="/contact">Contact Us</a></li>
  <li><a href="/privacypolicy">Privacy Policy</a></li>
  <li><a href="/terms">Terms And Conditions</a></li>
          </ul>
        </div>
        <div className="vangal-footer-right">
          <ul className="vangal-footer-links">
            <h2>Manufactured by:</h2>
            <p className="vangal-footer-company">VANGAL DAIRIES,<br />
54, Periyagoundampatti,<br /> Thalambadi Village,<br />
Namakkal,<br /> Tamil Nadu - 637019.</p>
          </ul>

          <ul className="vangal-footer-links">
            <p className="vangal-footer-company">Call Us : 04286-234369/259</p>
            <p className="vangal-footer-company">Mail Us : admin@vangalfarm.co.in</p>
          </ul>
          <div className="vangal-footer-social">
            <FaFacebookF />
            <FaInstagram />
            <FaLinkedinIn />
            <FaYoutube />
          </div>
        </div>

      </div>

      {/* Bottom Green Bar */}
      <div className="vangal-footer-bottom">
       © 2026 <strong>The Vangal Farms</strong> • Designed & Developed by <strong><a href="https://srirambranding.com" style={{ color: "white", textDecoration: "none" }}> Sriram Branding</a></strong>
      </div>
    </footer>
  );
};

export default Footer;
